import _ from 'lodash';

import * as constants from './AI.constants';
import * as services from './AI.service';

const state = {
  res_search: {},

  selectedBulletId: -1,

  isRequest: false,

  aiSearchRes: null,
  aiHistoryRes: null,

  selectedAiHistoryResIdx: -1,
};

const mutations = {
  [constants.SET_MAKE_AI_SEARCH_SUCCESS](state, res_search) {
    if (undefined !== res_search && null !== res_search) {
      state.res_search = res_search;
    }
  },

  [constants.SET_SELECTED_BULLET_ID](state, selectedBulletId) {
    state.selectedBulletId = selectedBulletId;
  },

  [constants.SET_SELECTED_AI_HISTORY_RES_IDX](state, selectedAiHistoryResIdx) {
    state.selectedAiHistoryResIdx = selectedAiHistoryResIdx;
  },

  [constants.SET_IS_REQUEST_STATUS](state, data) {
    state.isRequest = data;
  },

  [constants.DO_AI_SEARCH_RES](state, data) {
    if (undefined !== data && null !== data) {
      state.aiSearchRes = data;
      state.aiHistoryRes.splice(-1, 1, data);
    }
  },

  [constants.PUSH_QUESTION](state, data) {
    if (undefined !== data && null !== data) {
      state.aiHistoryRes.push(data);
    }
  },

  [constants.GET_AI_HISTORY_RES](state, data) {
    // state.aiHistoryRes = data;
    if (undefined !== data && null !== data) {
      state.aiHistoryRes = data;
    }
  },
};

const actions = {
  async makeAiSearch({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.makeAiSearch(payload);
    commit(constants.SET_MAKE_AI_SEARCH_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async doAiSearch({ commit }, payload) {
    try {
      commit(constants.SET_IS_REQUEST_STATUS, true);
      commit(constants.PUSH_QUESTION, { question: payload.search });
      const res = await services.doAiSearch(payload);
      commit(constants.DO_AI_SEARCH_RES, res.data.data);
    } catch (e) {
      console.error(e);
      commit(constants.DO_AI_SEARCH_RES, null);
    } finally {
      commit(constants.SET_IS_REQUEST_STATUS, false);
    }
  },
  async getAiHistory({ commit }, payload) {
    try {
      commit(constants.SET_IS_REQUEST_STATUS, true);
      const res = await services.getAiHistory(payload);
      commit(constants.GET_AI_HISTORY_RES, res.data.data);
    } catch (e) {
      console.error(e);
      commit(constants.GET_AI_HISTORY_RES, null);
    } finally {
      commit(constants.SET_IS_REQUEST_STATUS, false);
    }
  },
};

const getters = {
  res_search: (state) => {
    let resultvideo = state.res_search.resultvideo;
    resultvideo = resultvideo ? resultvideo : [];
    resultvideo = _.map(resultvideo, (video) => {
      return {
        ...video,
        courseId: video.course_id,
        courseName: video.course_name,
        bookId: video.book_id,
        bookName: video.book_name,
        readingId: video.reading_id,
        readingName: video.reading_name,
        bulletId: video.bullet_id,
        bulletName: video.bullet_name,
        videoId: video.video_id,
        vid: video.vid,
        durationString: video.longtime,
        start: video.begin_time,
        end: video.end_time,
        speed1: video.vpath_x1,
        speed1Dot3: video.vpath_x1,
        speed1Dot5: video.vpath_x1,
        speed2: video.vpath_x1,
      };
    });
    return {
      ...state.res_search,
      resultvideo,
    };
  },

  selectedVideo: (state, getters) => {
    let selectedVideo = _.find(
      getters.res_search.resultvideo,
      (video) => video.bulletId === state.selectedBulletId
    );
    selectedVideo = selectedVideo ? selectedVideo : {};
    return selectedVideo;
  },

  aiHistoryRes: (state) => {
    if (!state.aiHistoryRes) {
      return [];
    } else {
      return _.map(state.aiHistoryRes, (item, idxAiHistoryRes) => {
        return {
          ...item,
          resultVideo: _.map(item.resultVideo, (video, idx) => {
            return {
              ...video,
              courseId: video.courseId,
              courseName: video.courseName,
              bookId: video.bookId,
              bookName: video.bookName,
              readingId: video.readingId,
              readingName: video.readingName,
              bulletId: video.bulletId,
              bulletName: video.bulletName,
              videoId: video.videoId,
              vid: video.vid,
              durationString: video.duration,
              start: video.start / 1000,
              end: video.end / 1000 + 1,
              speed1: video.speed1,
              speed1Dot3: video.speed1Dot3,
              speed1Dot5: video.speed1Dot5,
              speed2: video.speed2,
              isLatest: item.resultVideo.length - 1 === idx,
              idxAiHistoryRes,
            };
          }),
        };
      });
    }
  },

  aiHistoryResResultVideos: (state, getters) => {
    const resultVideoGroups = _.map(getters.aiHistoryRes, (res) => {
      return res.resultVideo;
    });
    const aiHistoryResResultVideos = _.flatten(resultVideoGroups);
    return aiHistoryResResultVideos;
  },

  selectedAiHistoryVideoIdx: (state, getters) => {
    let selectedAiHistoryVideoIdx = _.findIndex(
      getters.aiHistoryResResultVideos,
      (video) =>
        video.bulletId === state.selectedBulletId &&
        video.idxAiHistoryRes === state.selectedAiHistoryResIdx
    );
    return selectedAiHistoryVideoIdx;
  },

  selectedAiHistoryVideo: (state, getters) => {
    let selectedAiHistoryVideo =
      getters.aiHistoryResResultVideos[getters.selectedAiHistoryVideoIdx];
    selectedAiHistoryVideo = selectedAiHistoryVideo ? selectedAiHistoryVideo : {};
    return selectedAiHistoryVideo;
  },

  selectedAiHistoryVideoNextBulletId: (state, getters) => {
    if (getters.selectedAiHistoryVideo.isLatest) {
      return -1;
    } else {
      return getters.aiHistoryResResultVideos[getters.selectedAiHistoryVideoIdx + 1].bulletId;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
